import {Component, ChangeDetectionStrategy, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MerchantAd} from '../../../../core/dtos/api';
import {UserSettingsApiService} from '../../../../core/services/api/user-settings-api.service';
import {of} from 'rxjs';
import {switchMap} from 'rxjs/operators';

@Component({
    templateUrl: './active-affiliates-dialog.component.html',
    styleUrls: ['./active-affiliates-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ActiveAffiliatesDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public merchantAd: MerchantAd, private userSettingsApiService: UserSettingsApiService) {}

  readonly displayColumns = ['affiliateCompanyName', 'affiliateDefaultWebsite'];

  $dataSource = of(this.merchantAd).pipe(
    switchMap(merchantAd => {
      if (!merchantAd.calculated_active_websites) {
        return of([]);
      }
      return this.userSettingsApiService.getMerchantAdActiveAffiliates(this.merchantAd.merchant_ad_id);
    })
  );

}
